// import _ from 'lodash';
import * as types from '../mutation-types';
import api from '../../api';

const LOCAL_STORAGE = 'faq';

const state = {
  faq: [],
  tage: [],
};

const localFAQ = {
  get() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE)) || [];
  },
  save() {
    localStorage.setItem(LOCAL_STORAGE, JSON.stringify(state.tage));
  },
};

const getters = {
  /* eslint-disable */
  getMostPopularQuestions: s => (flag) => {
    if (flag < Object.keys(s.faq).length) {
      return s.faq[flag + 1];
    }
    // if (flag === 0) {
    //   console.log(o);
    //   return _.filter(s.faq, o => o.sort > 90);
    // } else {
    //   return _.filter(s.faq, o => o.category === flag && o.sort > 10);
    // }
  },
  showThankTips: s => (id) => {
    let $type = false;
    if (s.tage.indexOf(id)) {
      $type = false;
    } else {
      $type = true
    }
    return $type;
  },
};

const actions = {
  fetchFAQ({ commit }) {
    return api.faq.get().then(({ data: response }) => {
      commit(types.RECEIVE_FAQ, response);
      commit(types.RECEIVE_TAGE, localFAQ.get());
    });
  },
  isItUseful({ commit }, params) {
    const { id, useful } = params;
    api.faq.isItUseful(id, useful).then(() => {
      commit(types.RECEIVE_TAGE, [id]);
      localFAQ.save();
      return Promise.resolve();
    });
  },
  submitQuestion(params) {
    return true;
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_FAQ](s, data) {
    s.faq = data;
  },
  [types.RECEIVE_TAGE](s, data) {
    s.tage = [...s.tage,...data];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
